<template>
    <PartStockAvailability :result="result" />
    <PartDataAge v-if="props.result.Distributor" :dist="props.result.Distributor" />
    <button
        v-if="showGlobalStock"
        ref="link"
        style="font-weight: bold"
        class="popper text-sm link-blue"
        @mouseenter="showPopup"
        @focus="showPopup"
        @mouseleave="hidePopup"
        @blur="hidePopup">
        {{ $t("Search.GlobalInventoryLink") }}
    </button>
    <div v-if="showGlobalStock" ref="tooltip" class="popper-tooltip" role="tooltip">
        <table class="w-full">
            <thead>
                <tr>
                    <th>{{ $t("Search.Region") }}</th>
                    <th>{{ $t("Global.Stock") }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(multiLocationInventory, index) in getMultiLocationInventory(props.result)" :key="index">
                    <td>{{ multiLocationInventory.RegionCode }}</td>
                    <td>{{ multiLocationInventory.Quantity.toLocaleString() }}</td>
                </tr>
            </tbody>
        </table>
        <p class="m-1 font-light">{{ $t("Search.SeeDistributorWebsite") }}</p>
    </div>
</template>

<script setup>
import { createPopper } from "@popperjs/core";

const props = defineProps({ result: { type: Object, required: true } });
const tooltip = ref();
const link = ref();

const showGlobalStock = computed(() => {
    return props.result.GlobalStock?.length > 0;
});

function getMultiLocationInventory(item) {
    if (item?.GlobalStock?.length > 0) {
        const res = item.GlobalStock.slice(0);
        res.sort(function (a, b) {
            if (a.RegionCode < b.RegionCode) return -1;
            if (a.RegionCode > b.RegionCode) return 1;
            return 0;
        });
        return res;
    }
    return [];
}

function hidePopup() {
    tooltip.value.removeAttribute("data-show");
}

function showPopup() {
    const popup = createPopper(link.value, tooltip.value, {
        placement: "bottom-start",
    });

    tooltip.value.setAttribute("data-show", "");
    popup.update();
}
</script>
